// ABOUTME: Decides whether an additional video is ready, still being transcoded, or never will be.
// ABOUTME: A recording without usable video never gets a Key/Url, so past a deadline it has failed.
import { AdditionalVideo } from '$types/additional-video/additional-video';

/**
 * Transcodes finish in minutes (in production, p90 under 9 minutes and p99
 * under an hour), so a video still without a file after this has failed.
 */
export const PROCESSING_DEADLINE_MS = 2 * 60 * 60 * 1000;

export type VideoStatus = 'ready' | 'processing' | 'failed';

type VideoFile = Pick<AdditionalVideo, 'Key' | 'Url' | 'CreateTime'>;

export const getVideoStatus = (
  video: VideoFile,
  now: number = Date.now()
): VideoStatus => {
  if (video.Key && video.Url) return 'ready';
  const createdAt = Date.parse(video.CreateTime);
  // Without a readable upload time, keep waiting rather than guess.
  if (Number.isNaN(createdAt)) return 'processing';
  return now - createdAt >= PROCESSING_DEADLINE_MS ? 'failed' : 'processing';
};

/** Whether reloading could still turn up a file: failed videos never get one. */
export const isAnyVideoProcessing = (
  videos: VideoFile[] | undefined,
  now: number = Date.now()
) =>
  Boolean(videos?.some((video) => getVideoStatus(video, now) === 'processing'));
